// SYRC-7180: shared background-job progress contract (generalized from the
// PC-specific draft). PC delete is the first consumer; other long-running jobs
// can reuse the same subscription/query by their own jobType.

/** Known job types. Extend as new background jobs adopt JobProgressService. */
export const JOB_TYPE_PC_DELETE = 'PC_DELETE';
/** SYRC-7421: company data reset. Its terminal state is shown as a dialog, not a toastr. */
export const JOB_TYPE_PC_RESET = 'PC_RESET';

// The mutation ack (JobAckResponse) is the generated type from awsAppSync/API.

/**
 * A single progress event from onJobProgress / getJobProgress. Structural subset
 * of the generated result (no __typename) so both the generated payload and any
 * synthetic seed satisfy it. `status` is "InProgress" | "Success" | "Failed".
 */
export interface JobProgressEvent {
  userId: string;
  jobId: string;
  jobType?: string | null;
  status?: string | null;
  percent?: number | null;
  phase?: string | null;
  message?: string | null;
  error?: { message?: string | null } | null;
}

/** UI-facing per-job state, demuxed by jobId. */
export interface JobProgressState {
  jobId: string;
  jobType: string;
  /** Human label supplied by the caller, e.g. "Deleting Acme". */
  label: string;
  percent: number;
  phase: string;
  status: string; // "InProgress" | "Success" | "Failed"
  /** false => centered modal (initial); true => collapsed bottom-right toast. */
  minimized: boolean;
  /** Last server message (completion summary, or the failure detail). */
  message?: string | null;
}

/**
 * localStorage marker entry so the toast survives reloads. Carries BOTH userId and
 * jobId because the reload-recovery seed query (getJobProgress) needs both — the
 * marker must be self-sufficient rather than relying on the store snapshot being
 * resolved at init time (SYRC-7180 brief).
 */
export interface ActiveJobMarker {
  userId: string;
  jobId: string;
  jobType: string;
  label: string;
  minimized?: boolean;
}
